import type {
  EntityContactRole,
  InvestmentEntityType,
  RegistryEntityContact,
} from '../api/registryEntityTypes';

export const ENTITY_TYPE_LABELS: Record<InvestmentEntityType, string> = {
  INDIVIDUAL: 'Individual',
  PARTNERSHIP: 'Partnership',
  COMPANY: 'Company',
  TRUST: 'Trust',
  SMSF: 'SMSF',
};

export const CONTACT_ROLE_LABELS: Record<EntityContactRole, string> = {
  OWNER: 'Owner',
  REPRESENTATIVE: 'Representative',
};

const REPRESENTATIVE_TYPE_LABELS: Record<string, string> = {
  FAMILY: 'Family',
  WEALTH_MANAGER: 'Wealth manager',
  ADVISOR: 'Adviser',
  ACCOUNTANT: 'Accountant',
};

export function representativeLabel(contact: RegistryEntityContact): string | null {
  if (contact.role !== 'REPRESENTATIVE') return null;
  if (contact.representativeType === 'OTHER') return contact.otherRepresentativeType || 'Other';
  return contact.representativeType
    ? (REPRESENTATIVE_TYPE_LABELS[contact.representativeType] ?? contact.representativeType)
    : null;
}

/** "$1,250,000.50" from a decimal string, without going through a float. */
export function formatAmount(amount: string): string {
  const [whole, cents = ''] = amount.replace(/^-/, '').split('.');
  const grouped = whole.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  return `${amount.startsWith('-') ? '-' : ''}$${grouped}.${cents.padEnd(2, '0').slice(0, 2)}`;
}

/** ABN as "12 345 678 901" and ACN as "123 456 789"; anything else is shown as stored. */
export function formatBusinessNumber(value: string | null): string | null {
  if (!value) return null;
  const digits = value.replace(/\s/g, '');
  if (/^\d{11}$/.test(digits))
    return digits.replace(/^(\d{2})(\d{3})(\d{3})(\d{3})$/, '$1 $2 $3 $4');
  if (/^\d{9}$/.test(digits)) return digits.replace(/^(\d{3})(\d{3})(\d{3})$/, '$1 $2 $3');
  return value;
}

export function isJointHolding(ownerCount: number): boolean {
  return ownerCount >= 2;
}
